import React, { forwardRef } from "react";
import { Loading } from "@tvg/design-system";
import { RaceTypeCodeEnum } from "@tvg/ts-types/Race";
import { isFdr } from "@tvg/pp/src/utils/general";
import AdvancedInfo from "../../AdvancedInfo";
import PerformanceInfo from "../../PerformanceInfo";
import Tags from "../../RunnerTags";
import InlineAnalyses from "../../InlineAnalyses";
import RunnerChanges from "../../RunnerChanges";
import InlinePastPerformance from "../../InlinePastPerformances";
import FollowHorse from "../../FollowHorse";
import ProfileNPps from "../../ProfileNPPs";
import {
  Container as ContentContainer,
  SeparatorLine
} from "../../../styled-components";
import { Container, Content } from "./styled-components";
import { RunnerInfoUIComponentProps } from "../types";

const RunnerInfoDesktop = forwardRef<
  HTMLDivElement,
  RunnerInfoUIComponentProps
>(
  (
    {
      isOpen,
      loading,
      height,
      runnerBI,
      isWPSBetType,
      bestPerformanceRunners,
      trackDataSource,
      emptyComments,
      isDriver,
      currentRace,
      runnerName,
      emptyCommentsHandicapping,
      timeform,
      changes,
      runnerNumber,
      pastRaces,
      selectedRacePP,
      handicapping,
      handleSelectRace,
      setSelectedRacePP,
      entityRunnerId,
      runnerDob,
      hasSilk
    },
    ref
  ) => {
    if (!isOpen)
      return (
        <Container
          isLoading={loading}
          isOpen={isOpen}
          data-qa-label="runner-handicap-inline-container"
          ref={ref}
          contentHeight={height}
          hasSilk={hasSilk}
        />
      );

    return (
      <Container
        isLoading={loading}
        isOpen={isOpen}
        data-qa-label="runner-handicap-inline-container"
        ref={ref}
        contentHeight={height}
        hasSilk={hasSilk}
      >
        {loading ? (
          <Loading size="s" qaLabel="runner-handicap-inline-loading" />
        ) : (
          <Content
            isOpen={isOpen && !loading}
            data-qa-label="runner-handicap-inline-content"
          >
            <AdvancedInfo
              runnerInfo={runnerBI}
              isScratched={runnerBI.isScratched}
              isWPSBetType={isWPSBetType}
              isInlineHandicapping
              bestPerformanceRunners={bestPerformanceRunners}
              hasSilk={hasSilk}
            />
            <PerformanceInfo
              runnerInfo={runnerBI}
              isScratched={runnerBI.isScratched}
              isDriver={isDriver}
              isInlineHandicapping
              bestPerformanceRunners={bestPerformanceRunners}
              hasSilk={hasSilk}
            />
            <Tags
              data={runnerBI.tags}
              isScratched={runnerBI.isScratched}
              handicapping={runnerBI.handicapping}
              timeform={runnerBI.timeform}
              trackDataSource={trackDataSource}
              isInlineHandicapping
              isTotalOfTags={isOpen}
              hasSilk={hasSilk}
            />
            {!emptyComments && !emptyCommentsHandicapping && (
              <>
                <SeparatorLine />
                <InlineAnalyses
                  trackDataSource={trackDataSource}
                  timeform={timeform}
                  handicapping={handicapping}
                />
              </>
            )}
            {changes?.jockey &&
            changes?.jockey.some((val) => val.runnerId === runnerNumber) ? (
              <>
                <SeparatorLine />
                <RunnerChanges
                  changes={changes}
                  runnerNumber={runnerNumber}
                  raceTypeCode={currentRace.type?.code || RaceTypeCodeEnum.ALL}
                />
              </>
            ) : null}
            <SeparatorLine />
            <InlinePastPerformance
              races={pastRaces}
              onSelectRace={handleSelectRace}
              currentRace={currentRace}
              currentRaceDistance={currentRace.distance}
              currentRaceSurface={currentRace.surface}
            />
            <SeparatorLine />
            <ContentContainer isRow>
              {!isFdr() && <FollowHorse runnerBI={runnerBI} />}
              {currentRace && (
                <ProfileNPps
                  entityRunnerId={entityRunnerId}
                  currentRace={currentRace}
                  runnerName={runnerName}
                  runnerDob={runnerDob}
                  selectedRacePP={selectedRacePP}
                  setSelectedRacePP={setSelectedRacePP}
                />
              )}
            </ContentContainer>
          </Content>
        )}
      </Container>
    );
  }
);

export default RunnerInfoDesktop;
